import React, { useEffect, useState } from "react"
import { Modal, ModalHeader, ModalBody } from "reactstrap"
import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"

function EmergencyDialog({ title, message, onClose }) {
  const { i18n } = useTranslation()
  const [displayMessage, setDisplayMessage] = useState(
    "An emergency has been reported."
  )

  // Function to show browser notification
  const showNotification = (title, body) => {
    // Check if the browser supports notifications
    if (!("Notification" in window)) {
      console.log("This browser does not support desktop notification")
      return
    }

    if (Notification.permission === "granted") {
      // If it's okay, let's create a notification
      new Notification(title, { body })
    } else if (Notification.permission !== "denied") {
      Notification.requestPermission().then(permission => {
        // If the user accepts, let's create a notification
        if (permission === "granted") {
          new Notification(title, { body })
        }
      })
    }
  }

  useEffect(() => {
    if (!message) return

    try {
      if ("Notification" in window) {
        Notification.requestPermission()
      }

      const [namePart] = message.split("type:")
      const name = namePart ? namePart.trim() : "A driver"

      const jsonMatch = message.match(/\{.*\}/s)
      if (jsonMatch) {
        const parsed = JSON.parse(jsonMatch[0].replace(/\\/g, ""))
        if (parsed.title && Array.isArray(parsed.title)) {
          const langMap = { en: 1, ar: 2, ur: 3, fa: 4, ps: 5 }
          const langKey = langMap[i18n.language] || 1
          const titleObj = parsed.title.find(item => item && item[langKey])
          const type = titleObj ? titleObj[langKey] : "emergency"
          const fullMessage = `${name} is facing an issue, type: ${type}`

          setDisplayMessage(fullMessage)

          showNotification("Emergency Alert", fullMessage)

          const handleVisibilityChange = () => {
            if (document.hidden) {
              showNotification("Emergency Alert", fullMessage)
            }
          }

          document.addEventListener("visibilitychange", handleVisibilityChange)

          return () => {
            document.removeEventListener(
              "visibilitychange",
              handleVisibilityChange
            )
          }
        }
      }
      setDisplayMessage(message)
    } catch (e) {
      console.error("Error parsing message:", e)
      setDisplayMessage(message)
    }
  }, [message, i18n.language])
  return (
    <Modal
      isOpen={true}
      toggle={onClose}
      className="modal-dialog-centered"
      backdrop="static"
    >
      <ModalHeader toggle={onClose} className="bg-danger text-white">
        <i className="mdi fw-bold mdi-alert-circle-outline me-2"></i>
        {title || "Emergency Alert"}
      </ModalHeader>
      <ModalBody className="py-4">
        <div className="text-center">
          <i
            className="mdi fw-bold mdi-alert-circle-outline text-danger"
            style={{ fontSize: "4rem" }}
          ></i>
          <h4 className="fs-2 mt-2 fw-bold">{title || "Emergency Alert"}</h4>
          <div className="mt-3 p-2 rounded">
            <p
              style={{
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                margin: 0,
              }}
              className="fs-5"
            >
              {displayMessage}
            </p>
          </div>
          <Link to="/driver-emergencies">
            <button
              className="btn btn-danger mt-3 mb-2 px-5 fs-5"
              onClick={() => {
                console.log("Acknowledging emergency notification")
                onClose()
              }}
            >
              See Details
            </button>
          </Link>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default EmergencyDialog
